import { IUser } from '../user/user';
import { IFile } from '../global/file';

export enum JourneyType {
  BookingId = 'BOOKING_ID',
  BookingCode = 'BOOKING_CODE',
  JourneyCode = 'JOURNEY_CODE',
  JourneyId = 'JOURNEY_ID',
  BookerReference = 'BOOKER_REFERENCE',
  PartnerReference = 'PARTNER_REFERENCE',
}

export const JourneyTypeDsiplayName = {
  [JourneyType.BookingId]: 'Booking id',
  [JourneyType.BookingCode]: 'Booking code',
  [JourneyType.BookerReference]: 'Booking reference',
  [JourneyType.JourneyId]: 'Journey id',
  [JourneyType.JourneyCode]: 'Journey code',
  [JourneyType.PartnerReference]: 'Partner reference',
};

export enum DateFormatType {
  DD_MM_YYYY = 'DD_MM_YYYY',
  MM_DD_YYYY = 'MM_DD_YYYY',
  YYYY_MM_DD = 'YYYY_MM_DD',
}

export const DateFormatTypeDisplayName = {
  [DateFormatType.DD_MM_YYYY]: 'DD/MM/YYYY',
  [DateFormatType.MM_DD_YYYY]: 'MM/DD/YYYY',
  [DateFormatType.YYYY_MM_DD]: 'YYYY/MM/DD',
};

export enum ReviewRateRangeType {
  RANGE_0_5 = 'RANGE_0_5',
  RANGE_1_5 = 'RANGE_1_5',
  RANGE_0_10 = 'RANGE_0_10',
  RANGE_1_10 = 'RANGE_1_10',
  RANGE_0_100 = 'RANGE_0_100',
  RANGE_1_100 = 'RANGE_1_100',
}

export const ReviewRateRangeTypeDsiplayName = {
  [ReviewRateRangeType.RANGE_0_5]: '0 - 5',
  [ReviewRateRangeType.RANGE_1_5]: '1 - 5',
  [ReviewRateRangeType.RANGE_0_10]: '0 - 10',
  [ReviewRateRangeType.RANGE_1_10]: '1 - 10',
  [ReviewRateRangeType.RANGE_0_100]: '0 - 100',
  [ReviewRateRangeType.RANGE_1_100]: '1 - 100',
};

export enum CsvFileSeparatorType {
  Comma = 'COMMA',
  Semicolon = 'SEMICOLON',
  Tab = 'TAB',
}

export const CsvFileSeparatorTypeDisplayName = {
  [CsvFileSeparatorType.Comma]: 'Comma',
  [CsvFileSeparatorType.Semicolon]: 'Semicolon',
  [CsvFileSeparatorType.Tab]: 'Tab',
};

export interface IReviewFileJsonDataParams {
  containsHeaders: boolean;
  separator: string;
}

export interface IReviewFileHeader {
  index: number;
  name: string;
}

export interface IPreviewReviewFileParams {
  id: number;
  columnMapping: {
    journey: string,
    journeyMappingType: string,
    pickupDate: string,
    pickupDateFormat: string,
    reviewRating: string,
    reviewRateRange: string,
    firstName: string,
    lastName: string,
    email: string,
    comment: string,
    positiveComment: string,
    negativeComment: string,
  };
}

export interface IReviewFile {
  id: number;
  fileName: string;
  created: string;
  storageId: number;
  user: IUser;
  file: IFile;
  status: string;
}

export interface IReviewFilePreviews {
  previews: IReviewFilePreview[];
  errors: IReviewFileError[];
}

export interface IReviewFilePreview {
  rowNumber: number;
  journeyCode: string;
  reviewRating: string;
  comment: string;
  name: string;
  email: string;
}

export interface IReviewFileError {
  rowNumber: number;
  errorTypes: string[];
}

export enum ReviewFileErrorType {
  Journey = 'JOURNEY',
  ReviewRating = 'REVIEW_RATING',
  PickupDate = 'PICKUP_DATE',
  FirstName = 'FIRST_NAME',
  LastName = 'LAST_NAME',
  Email = 'EMAIL',
  Comment = 'COMMENT',
  PositiveComment = 'POSITIVE_COMMENT',
  NegativeComment = 'NEGATIVE_COMMENT',
}

export const ReviewFileErrorDisplayName = {
  [ReviewFileErrorType.Journey]: 'Journey',
  [ReviewFileErrorType.ReviewRating]: 'Review rating',
  [ReviewFileErrorType.PickupDate]: 'Pickup date',
  [ReviewFileErrorType.FirstName]: 'First name',
  [ReviewFileErrorType.LastName]: 'Last name',
  [ReviewFileErrorType.Email]: 'Email',
  [ReviewFileErrorType.Comment]: 'Comment',
  [ReviewFileErrorType.PositiveComment]: 'Postive comment',
  [ReviewFileErrorType.NegativeComment]: 'Negative comment',
};

export interface IReview {
  id: number;
  journeyId: number;
  partnerId: number;
  score: number;
  comment: string;
  reviewerName: string;
  reviewerEmail: string;
  source: string;
  createdByUserId: number;
  created: string;
  reviewFileId: number;
}

export interface IReviewsParams {
  journeyId: number;
  partnerId: number;
  createdAfter: string;
  createdBefore: string;
  reviewSource: string;
  reviewFileId: number;
  page: number;
  size: number;
  sort: string[];
}

export enum ReviewFileStatusType {
  PendingUpload = 'PENDING_UPLOAD',
  Uploaded = 'UPLOADED',
  Validating = 'VALIDATING',
  Validated = 'VALIDATED',
  Importing = 'IMPORTING',
  Imported = 'IMPORTED',
  Error = 'ERROR',
}

export const ReviewFileStatusDisplayName = {
  [ReviewFileStatusType.PendingUpload]: 'Pending upload',
  [ReviewFileStatusType.Uploaded]: 'Uploaded',
  [ReviewFileStatusType.Validating]: 'Validating',
  [ReviewFileStatusType.Validated]: 'Validated',
  [ReviewFileStatusType.Importing]: 'Importing',
  [ReviewFileStatusType.Imported]: 'Import completed',
  [ReviewFileStatusType.Error]: 'Error',
}
